import React from "react";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from "@chakra-ui/react";
import { isAxiosError } from "axios";

/**
 * Inline §7.0 error under a choice card when creating the application fails. Shows the backend's
 * message when it sends one (e.g. the account isn't set up for applications yet).
 */
const ApplicationStartError = ({ error }: { error: unknown }) => {
  const message = isAxiosError(error) ? error.response?.data?.message : undefined;

  return (
    <Alert status="error" alignItems="flex-start">
      <AlertIcon />
      <Box flex="1">
        <AlertTitle>We couldn't start this application</AlertTitle>
        <AlertDescription>
          {typeof message === "string" ? message : "Check your connection and try again."}
        </AlertDescription>
      </Box>
    </Alert>
  );
};

export default ApplicationStartError;
